import API from "./axios";

/**
 * Barcode Operations — the stitching operations each barcode needs, their line
 * order, and the job work rate per piece of each on that barcode. Barcodes go
 * as a query parameter (`code`); a production barcode is resolved to its
 * product barcode by the server.
 */
const barcodeOperationApi = {
  paged:          (params = {}) => API.get("/barcode-operations/paged", { params }),
  /** Product barcodes on sale orders, for the pick list. */
  searchBarcodes: (q = "")      => API.get("/barcode-operations/search-barcodes", { params: { q } }),
  getByBarcode:   (code)        => API.get("/barcode-operations/by-barcode", { params: { code } }),
  /** body: { barcode, operations: [{ operationId, jobWorkRate, sortOrder }] } — the full list, rate required. */
  save:           (body)        => API.put("/barcode-operations/by-barcode", body),
  remove:         (code)        => API.delete("/barcode-operations/by-barcode", { params: { code } }),
};

export default barcodeOperationApi;
